export default __webpack_public_path__ + "static/media/27.0363b44c.jpeg";